import { emptyProgress, type ProgressData } from '../core/progress';

// localStorage-backed progress, SCOPED per identity so accounts don't share/bleed
// progress: guest uses the base key, a signed-in user uses a per-user key. When signed
// in, the backend is authoritative and this is the per-user cache/offline fallback.
const BASE = 'loki.progress.v1';

export const GUEST_SCOPE = 'guest';

function keyFor(scope: string): string {
  return scope === GUEST_SCOPE ? BASE : `${BASE}.${scope}`;
}

export function loadProgress(scope: string = GUEST_SCOPE): ProgressData {
  try {
    const raw = localStorage.getItem(keyFor(scope));
    if (raw) return JSON.parse(raw) as ProgressData;
  } catch {
    // ignore corrupt/unavailable storage — start fresh
  }
  return emptyProgress();
}

export function saveProgress(data: ProgressData, scope: string = GUEST_SCOPE): void {
  try {
    localStorage.setItem(keyFor(scope), JSON.stringify(data));
  } catch {
    // ignore quota/unavailable storage
  }
}
